import { render, staticRenderFns } from "./LegendSelectorAntV.vue?vue&type=template&id=07ba7094&scoped=true"
import script from "./LegendSelectorAntV.vue?vue&type=script&lang=js"
export * from "./LegendSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./LegendSelectorAntV.vue?vue&type=style&index=0&id=07ba7094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ba7094",
  null
  
)

export default component.exports